import moment from 'moment';
import { BehaviorSubject, Observable, of } from 'rxjs';

export class EntraIdAuthMock {
  public loggingIn$ = new BehaviorSubject<boolean>(true);

  login(): void {
    return;
  }

  logout(): void {
    return;
  }

  logoutSilent(): void {
    return;
  }

  isLoggedIn(): Observable<boolean> {
    return of(true);
  }

  validateToken(): boolean {
    return true;
  }

  async validateTokenAsync(): Promise<boolean> {
    return Promise.resolve(true);
  }

  private checkExpiration(expiration: string): boolean {
    return moment().isBefore(Number(expiration));
  }
}
